<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <path d="M0.967769 0.0514945L16.3222 7.61746C16.5699 7.73952 16.6718 8.03927 16.5497 8.28697C16.501 8.3858 16.4211 8.46578 16.3222 8.51448L0.968085 16.0803C0.720382 16.2023 0.420632 16.1005 0.298576 15.8528C0.245204 15.7445 0.232832 15.6205 0.263745 15.5038L2.23244 8.07012L0.263398 0.627888C0.192768 0.360932 0.351921 0.087263 0.618878 0.0166325C0.735571 -0.0142416 0.859493 -0.001859 0.967769 0.0514945ZM1.51109 1.43403L3.12021 7.51612L3.18219 7.50412L3.24664 7.5H10.2466C10.5228 7.5 10.7466 7.72386 10.7466 8C10.7466 8.24546 10.5698 8.44961 10.3365 8.49194L10.2466 8.5H3.24664C3.21524 8.5 3.18451 8.4971 3.15471 8.49157L1.51172 14.6976L14.97 8.06597L1.51109 1.43403Z" />
  </svg>
</template>
